import MapOutlined from '@mui/icons-material/MapOutlined'

import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import Section from '@components/Details/Section'

import Field from './Field'

export default function Coverage({ data, isLoading }) {
  const locations = data?.coveredCounties || []

  return (
    <Section title="Coverage" icon={<MapOutlined />}>
      <Stack sx={{ gap: 1 }}>
        {isLoading && <Field label="State" isLoading labelWidth={40} />}
        {!isLoading && locations.length === 0 && <Typography sx={{ color: 'text.secondary' }}>No coverage</Typography>}
        {!isLoading &&
          locations.map(({ state, counties }, i) => (
            <Field key={i} label={state} value={counties?.length > 0 ? counties.join(', ') : 'ALL'} labelWidth={40} />
          ))}
      </Stack>
    </Section>
  )
}
